export const allowedDomains = [
  'com', 'org', 'io', 'net', 'gov', 'edu', 'mil', 'int', 'eu', 'biz',
  'aero', 'museum', 'coop', 'name', 'pro', 'info', 'jobs',
  'mobi', 'travel', 'asia', 'tel', 'cat', 'post', 'arpa'
];


const clientId = process.env.REACT_APP_CLIENT_ID;
const appName = process.env.REACT_APP_NAME;
const tenantApiUrl = process.env.REACT_APP_TENANT_API_URL;
const keycloackUrl = process.env.REACT_APP_KEYCLOACK_API_URL;
const redirectUri = process.env.REACT_APP_REDIRECT_URL;
const logoutRedirectUri=process.env.REACT_APP_REDIRECT_LOGOUT_URL;

export const authConfiguration = {
  clientId: `${clientId}`,
  appName: `${appName}`,
  tenantApiUrl: `${tenantApiUrl}`,
  keycloackUrl: `${keycloackUrl}`,
  redirectUri: `${redirectUri}`,
  logoutRedirectUri: `${logoutRedirectUri}`,
}

// export const afterLoginpaths=['/','/login','/users','/applications','/settings','/logout','/homepage','/logincheck','/setpassword','/profile','/subscription','/groups','/unauthorize','/key','/billpayments','/teams'];
export const afterLoginpaths=['/admin/','/admin/login','/admin/users','/admin/applications','/admin/settings','/admin/logout','/admin/homepage','/admin/logincheck','/admin/setpassword','/admin/profile','/admin/subscription','/admin/groups','/admin/unauthorize','/admin/key','/admin/billpayments','/admin/teams'];

// export const beforeLoginpaths=['/login','/','/logout','/setpassword', '/alreadyjoined','/unauthorize'];
export const beforeLoginpaths=['/admin/login','/admin/','/admin/logout','/admin/setpassword', '/admin/alreadyjoined','/admin/unauthorize'];